module.exports = __webpack_public_path__ + "static/media/project-1.9f0eab8b.jpg";